<template>
  <div class="w100 pt20 pb20 pl20 pr20 bg-w">
    自定义服务
  </div>
</template>

<script>
export default {
  name: "Customized",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
